import {getCurrentSession} from '../services/auth'
import type {HttpOptions, HttpUploadOptions} from '../services/http'

import {
  HttpFetchOptions,
  fetchBlob as httpFetchBlob,
  upload as httpUpload,
  jsonFetch,
} from './http-json'

const createHttpJsonAuth = (isServer: boolean) => {
  const applyAuthorization = async <T extends HttpOptions>(options: T): Promise<T> => {
    if (isServer) {
      return options
    }

    const sessionToken = await getCurrentSession()

    return {
      ...options,
      headers: {
        ...(sessionToken
          ? {
              ...(options.headers ? options.headers : {}),
              Authorization: `Bearer ${sessionToken}`,
            }
          : options.headers || {}),
      },
    }
  }

  const fetch: typeof jsonFetch = async (url, options = {}, retryOptions) => {
    const authOptions = await applyAuthorization<HttpFetchOptions>(options)
    return jsonFetch(url, authOptions, retryOptions)
  }

  const fetchBlob = async (url: string, options = {}): Promise<Blob> => {
    const authOptions = await applyAuthorization<HttpFetchOptions>(options)
    return httpFetchBlob(url, authOptions)
  }

  const upload = async (options: HttpUploadOptions) => {
    const authOptions = await applyAuthorization<HttpUploadOptions>(options)
    return httpUpload(authOptions)
  }

  return {
    fetch,
    fetchBlob,
    upload,
  }
}

export default createHttpJsonAuth
